import { createSelector } from '@reduxjs/toolkit';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  illiquidSecurityAllIds,
  illiquidSecurityById,
  allIlliquidSecuritiesSelector,
] = resourceSelectors('illiquidSecurities');
